(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ReportDownloadService', ReportDownloadService);

    /** @ngInject */
    function ReportDownloadService($http, $q, $window, $httpParamSerializer, ROUTES) {
        let cachedToken = null;
        let cachedExpires = 0;

        const service = {
            download: download,
            getToken: getToken
        };

        return service;

        // Busca (com Bearer, via interceptor) um token assinado de curta duração e o reaproveita
        // enquanto válido, renovando 30s antes de expirar.
        function getToken() {
            const now = Math.floor(Date.now() / 1000);

            if (cachedToken && now < (cachedExpires - 30)) {
                return $q.resolve(cachedToken);
            }

            return $http
                .get(`${ROUTES.API}/reports/download-token`)
                .then(response => {
                    cachedToken = response.data.Token;
                    cachedExpires = response.data.Expires;
                    return cachedToken;
                });
        }

        // Dispara o download do relatório. A resposta vem como attachment, então definir
        // window.location.href apenas baixa o arquivo, sem navegar para fora da página.
        function download(path, parameters) {
            return getToken().then(token => {
                const query = $httpParamSerializer(angular.extend({}, parameters, { DownloadHash: token }));
                $window.location.href = `${ROUTES.API}/${path}?${query}`;
            });
        }
    }
})();
